import React from 'react';
import { Menu, Icon, Modal, Input, Divider, Button, Message } from 'semantic-ui-react';

/* props: jsonImport */

// CSS Stuff
const inlineStyle = {
  modal : {
    position: 'fixed',
    top: '25%',
    left: '20%'
  }
};

class ImportJSONButton extends React.Component {
  state = {open : false,
           import : null,
           warn : false};
  openModal = this.openModal.bind(this);
  handleFiles = this.handleFiles.bind(this);
  checkFile = this.checkFile.bind(this);
  importFile = this.importFile.bind(this);
  
  close = () => this.setState({ open: false, warn : false});

  openModal() {this.setState({open : true})}

  handleFiles(e,d) {
    let reader = new FileReader();
    reader.onloadend = this.checkFile;
    reader.readAsText(e.target.files[0]);
    //const jport = JSON.parse(reader.result);
    //this.props.jsonImport(jport);
  }

  checkFile(e) {
    try {
      let jport = JSON.parse(e.target.result);
      this.setState({import : jport,
                     warn : false});
      //console.log(jport);
    } catch(e) {
      this.setState({warn : true});
      //console.log("Import Error");
    }
  }

  importFile() {
    const jport = this.state.import;
    if (jport !== null) {
      this.props.jsonImport(jport)
    }
    this.close();
  }

  render() {
    const {open, warn} = this.state;
    const good2go = this.state.import === null ? false : true;
    
    return(
      <div>
      <Menu.Item onClick={this.openModal} >
        <Icon name="upload" /> Import JSON File
      </Menu.Item>

      <Modal dimmer='inverted' open={open} onClose={this.close} style={inlineStyle.modal} closeIcon>
        <Modal.Header><Icon name="upload"/>Import JSON File</Modal.Header>
        <Modal.Content>
          Import an existing mod-PATH3DU Primary File you'd wish to edit.
          Files are <i>not</i> uploaded to a server and remain on your computer.
          <Message negative hidden={!warn} >
            The file chosen is not valid JSON. It cannot be imported.
          </Message>
          <Divider />
          <Input type="file" onChange={this.handleFiles} accept=".json" />
          <Message compact color="green" hidden={!good2go}><Icon name="check" color="green" />Valid JSON</Message>
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={this.close} icon>Close<Icon name="close" /></Button>
          <Button color="green" onClick={this.importFile} icon disabled={!good2go}>Import</Button>
        </Modal.Actions>
      </Modal>
      </div>
    );
  }

}

export default ImportJSONButton;
